<template>
  <button
    :disabled="isSpinning || disabled"
    @click="$emit('click')"
    class="button-spinner"
  >
    <span class="spinner-wrapper" v-if="isSpinning">
      <i class="fa fa-spinner fa-pulse"></i>
    </span>
    <span :class="{ invisible: isSpinning }"><slot /></span>
  </button>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ButtonSpinner',
  props: {
    isSpinning: {
      type: Boolean,
    },
    disabled: {
      type: Boolean,
    },
  },
  emits: ['click'],
});
</script>

<style lang="scss" scoped>
button {
  position: relative;

  .spinner-wrapper {
    left: 0;
    margin-left: 0;
    position: absolute;
    width: 100%;
  }
}
</style>
